import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Homepage from './landing/pages/Homepage9';
import Privacy from './landing/pages/Privacy2';
import TermsOfUse from './landing/pages/TermsOfUse2';
import Socials from './landing/pages/Socials2';
import VendorMapPage from './landing/pages/MapPage5';
import Dashboard from './authenticated/pages/Dashboard3';
import Signin from './landing/pages/Signin3';

// Sign-in protection and pop-up messages, shared by the whole site
import AuthGuard from './auth/AuthGuard';
import { ToastProvider } from './shared/components/status';

// ── QC module ───────────────────────────────────────────────────────────────
import QcLogin from './qualitycontrol/pages/QcLogin';
import QcHome from './qualitycontrol/pages/QcHome';
import MaterialsQc from './qualitycontrol/pages/materials-qc/MaterialsQc';
import SpacePlanningQc from './qualitycontrol/pages/space-planning-qc/SpacePlanningQc';
import ManagementDashboard from './qualitycontrol/pages/management/ManagementDashboard';

function ScrollToTopOnRouteChange() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

const App = () => {
  return (
    <ToastProvider>
      <Router>
        <ScrollToTopOnRouteChange />
        <Routes>
          {/* ── Public pages ── */}
          <Route path="/" element={<Homepage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route path="/socials" element={<Socials />} />
          <Route path="/showrooms" element={<VendorMapPage />} />
          <Route path="/signin" element={<Signin />} />

          {/* ── Customer dashboard: needs a customer sign-in ── */}
          <Route path="/dashboard" element={<AuthGuard><Dashboard /></AuthGuard>} />

          {/* ── QC module: separate sign-in, no relation to the customer session ── */}
          <Route path="/qc/login" element={<QcLogin />} />
          <Route path="/qc" element={<AuthGuard area="qc"><QcHome /></AuthGuard>} />
          <Route path="/qc/materials" element={<AuthGuard area="qc"><MaterialsQc /></AuthGuard>} />
          <Route path="/qc/space-planning/:phonenumber" element={<AuthGuard area="qc"><SpacePlanningQc /></AuthGuard>} />
          <Route path="/qc/management" element={<AuthGuard area="qc"><ManagementDashboard /></AuthGuard>} />
        </Routes>
      </Router>
    </ToastProvider>
  );
};

export default App;
